<script lang="ts">
  /**
   * One Lucide icon, rendered from the package's geometry data.
   *
   * The geometry comes from `lucide` (ISC) rather than `lucide-svelte` because
   * this project compiles every component in runes mode (`svelte.config.js`),
   * and lucide-svelte's components are legacy-mode — they spread `$$props`,
   * which the runes compiler rejects outright. The icon set is data
   * (`[[tag, attrs], …]`), so it survives any compiler mode, and importing one
   * `.mjs` per icon keeps the bundle to the icons actually used.
   *
   * Always decorative. The accessible name is the button's own label, so every
   * icon here is `aria-hidden` and `focusable="false"` — an icon that announced
   * itself would make "Finished" read as "check mark Finished".
   */
  import type { IconNode } from 'lucide';

  interface Props {
    /** An icon's geometry: `import Check from 'lucide/dist/esm/icons/check.mjs'`. */
    node: IconNode;
    size?: number;
  }

  let { node, size = 14 }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  {#each node as [tag, attrs], i (i)}
    <svelte:element this={tag} {...attrs} />
  {/each}
</svg>